module.exports = __webpack_public_path__ + "static/media/ec.b2f7f916.png";